import $ from 'jquery';
import throttle from 'lodash/throttle';
import registerJQueryPlugin from '../lib/register-jquery-plugin';

/**
 * Calculates the scroll y position of the threshold element.
 * @param {jQuery} $window - Window in the environment
 * @param {jQuery} $document - Document in the environment
 * @param {jQuery} $threshold - Threshold element
 * @returns {number} Scroll y position of the threshold element
 */
const getScrollYPosition = ($window, $document, $threshold) => {
  const docHeight = $document.height();
  const windowHeight = $window.height();
  const exceedingHeight = $threshold.outerHeight(true);
  return docHeight - exceedingHeight - windowHeight;
};

/**
 * Adds click handler to close NTF
 * @returns {void}
 */
const toast = () => {
  const toast = $('.fixed-toast');
  const close = $('.fixed-toast--close');

  $(close).on('click', function() {
    $(toast).hide();
  });
}

/**
 * Applies class to element whenever it hits a threshold.
 * @param {HTMLElement} - Element receiving class when threshold is hit
 * @param {Object} [options={}]
 * @param {Object} [options.window=window] - Window in the environment
 * @param {HTMLElement} [options.document=document] - Document in the environment
 * @param {string} [options.blockName='fixed-corner'] - Block name in BEM
 * scheme for instance
 * @param {string} [options.offModifier='off'] - Modifier when threshold is hit
 * @param {string} [options.controlModifier='center'] - Modifier denoting no
 * functionality should be applied
 * @param {string} [options.thresholdSelector='.site-footer'] - Selector used to
 * denote when the class should be applied
 * @param {number} [options.wait=100] - Time which throttle should be applied to
 * scroll/resize event
 */
export default function fixedCorner(el, options = {}) {
  const $el = $(el);
  const {
    window: win = window,
    document: doc = document,
    blockName = 'fixed-corner',
    offModifier = 'off',
    controlModifier = 'center',
    thresholdSelector = '.site-footer',
    wait = 100,
  } = Object.assign({}, options, $el.data());

  const $window = $(win);
  const $document = $(doc);
  const offClassName = `${blockName}--${offModifier}`;
  const controlClassName = `${blockName}--${controlModifier}`;
  const $threshold = $(thresholdSelector);

  $window.on('scroll resize', throttle(() => {
    const thresholdScrollYPosition = getScrollYPosition($window, $document, $threshold);
    if ($el.hasClass(controlClassName)) {
      return;
    }

    const scrollYPosition = $window.scrollTop();
    if (scrollYPosition >= thresholdScrollYPosition) {
      return $el.addClass(offClassName);
    }

    return $el.removeClass(offClassName);
  }, wait));
}

$(() => {
  toast();
});

registerJQueryPlugin('fixedCorner', fixedCorner);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/fixed-corner.js